import { observer } from "mobx-react-lite";
import { useMemo, useState } from "react";
import { useStore } from "../../../stores";
import Message from "./Message";
import { messageAdapter } from "../../../services/chathub";
import { LuPinOff } from "react-icons/lu";
import { LuPin } from "react-icons/lu";
import "./PinedMessage.module.scss";

const PinedMessage = () => {
  const { selectedChat, unpinMessage } = useStore("chats");
  const [btnLoading, setBtnLoading] = useState(false);

  const pinnedMessage = useMemo(() => {
    if (!selectedChat) return null;

    return (
      selectedChat?.data?.pinMessage &&
      JSON.parse(selectedChat?.data?.pinMessage || "{}")
    );
  }, [selectedChat]);

  const message = useMemo(() => {
    if (!pinnedMessage) return null;
    return messageAdapter(pinnedMessage.message);
  }, [pinnedMessage]);

  const highlightMessage = () => {
    if (!message) return;
    document.getElementById("chat-message-" + message.id)?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const onUnpin = async () => {
    if (!selectedChat) return;

    setBtnLoading(true);
    try {
      await unpinMessage();
    } catch (error) {
      console.log("error", error);
    } finally {
      setBtnLoading(false);
    }
  };

  if (!selectedChat || !pinnedMessage || !message) {
    return null;
  }

  return (
    <div className="is-align-items-center px-2 has-background-white-ter has-border has-rounded-corners is-flex w-100">
      <button
        onClick={onUnpin}
        disabled={btnLoading}
        className="pin-message-button button is-ghost is-no-box-shadow px-1"
      >
        <LuPin size={24} className="icon-pinned" />
        <LuPinOff size={24} className="icon-unpinned" />
      </button>
      <div
        className="has-ellipsis-text is-clickable"
        onClick={highlightMessage}
      >
        <Message onlyText message={message} />
      </div>
    </div>
  );
};

export default observer(PinedMessage);
